import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportDataResponse, ImportError } from 'src/app/core/interfaces/import-data.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-import-results-modal',
  templateUrl: './import-results-modal.component.html',
  styleUrls: ['./import-results-modal.component.css']
})
export class ImportResultsModalComponent implements OnInit {
  @Input() importResult!: ImportDataResponse;
  @Input() entityName: string = '';

  readonly itemsPerPage = 25;
  readonly visiblePages = 5;

  currentPage = 1;
  totalPages = 1;

  constructor(
    public activeModal: NgbActiveModal,
    private localizationService: LocalizationService
  ) { }

  ngOnInit(): void {
    this.updatePagination();
  }

  getCurrentLanguage(): string {
    return this.localizationService.getCachedLanguage() ?? 'en';
  }

  getSuccessMessage(): string {
    const isArabic = this.getCurrentLanguage() === 'ar';
    const { countSuccess, countFailed } = this.importResult.data;

    if (isArabic) {
      return `تم استيراد ${countSuccess} عنصر بنجاح، فشل ${countFailed} عنصر`;
    }

    return `${countSuccess} items imported successfully, ${countFailed} failed`;
  }

  getTotalItems(): number {
    return this.importResult.data.countSuccess + this.importResult.data.countFailed;
  }

  hasErrors(): boolean {
    return this.importResult.data.errors?.length > 0;
  }

  getErrorCount(): number {
    return this.importResult.data.errors?.length ?? 0;
  }

  getPaginatedErrors(): ImportError[] {
    const errors = this.importResult.data.errors ?? [];
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return errors.slice(startIndex, startIndex + this.itemsPerPage);
  }

  setPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  getFirstItemIndex(): number {
    if (this.getErrorCount() === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getLastItemIndex(): number {
    const end = this.currentPage * this.itemsPerPage;
    return Math.min(end, this.getErrorCount());
  }

  getPages(): number[] {
    const pages: number[] = [];
    let startPage = Math.max(1, this.currentPage - Math.floor(this.visiblePages / 2));
    const endPage = Math.min(this.totalPages, startPage + this.visiblePages - 1);

    startPage = Math.max(1, endPage - this.visiblePages + 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  trackByError(_index: number, error: ImportError): string {
    return `${error.rowNumber}-${error.reason}`;
  }

  private updatePagination(): void {
    const errorCount = this.getErrorCount();
    this.totalPages = Math.max(1, Math.ceil(errorCount / this.itemsPerPage));
    this.currentPage = 1;
  }
}
